// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loadingViewContent {
    display: flex;
    width: 100%;
    height: 100%;

    aspect-ratio: 16/9;

    background-color: black;

    align-items: center;
    justify-content: center;
}

#loadingContainer {
    display: flex;
    max-width: 177.778vh;
    max-height: 56.25vw;
    
    aspect-ratio: 16/9;
    
    background-color: black;
}

#textHolder {
    position: absolute;
  
    aspect-ratio: 16/9;

    width: 100%;
    max-width: 177.778vh;
    max-height: 56.25vw;

    container-type: size;

    z-index: 6;
}


#mainLoadingText {
    bottom: 0%;
    left: 45%;
    transform: translate(0%, -100%);

    font-size: 3.8cqh;

    padding: 0;
    margin: 0;
}

#extraLoadingText {
    bottom: 0%;

    transform: translate(-50%, -100%);

    font-size: 1.6cqh;

    padding: 0;
    margin: 0;
}

.loadingText {
    position:absolute;
    z-index: 6;
    left: 50%;
    transform: translate(-50%);

    color: white;
    font-family: 'MyriadPro-Regular';
    text-transform: uppercase;
    font-weight: bold;
}

.fadeOutText {
    animation: extraTextfade 5s ease-in-out 0s 1 normal forwards;
}

.fadeInText {
    animation: fadeIn 1s ease-in-out 0s 1 normal forwards;
}

@keyframes extraTextfade {
    0% {
        opacity: 0;
    }
    20% {
        opacity: 1;
    }
    80% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Loading.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB,uBAAuB;;IAEvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;;IAEnB,kBAAkB;;IAElB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB,kBAAkB;;IAElB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;;IAEnB,oBAAoB;;IAEpB,UAAU;AACd;;;AAGA;IACI,UAAU;IACV,SAAS;IACT,+BAA+B;;IAE/B,iBAAiB;;IAEjB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;;IAEV,iCAAiC;;IAEjC,iBAAiB;;IAEjB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,0BAA0B;;IAE1B,YAAY;IACZ,gCAAgC;IAChC,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":["#loadingViewContent {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    aspect-ratio: 16/9;\r\n\r\n    background-color: black;\r\n\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n#loadingContainer {\r\n    display: flex;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    \r\n    aspect-ratio: 16/9;\r\n    \r\n    background-color: black;\r\n}\r\n\r\n#textHolder {\r\n    position: absolute;\r\n  \r\n    aspect-ratio: 16/9;\r\n\r\n    width: 100%;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n\r\n    container-type: size;\r\n\r\n    z-index: 6;\r\n}\r\n\r\n\r\n#mainLoadingText {\r\n    bottom: 0%;\r\n    left: 45%;\r\n    transform: translate(0%, -100%);\r\n\r\n    font-size: 3.8cqh;\r\n\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n#extraLoadingText {\r\n    bottom: 0%;\r\n\r\n    transform: translate(-50%, -100%);\r\n\r\n    font-size: 1.6cqh;\r\n\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.loadingText {\r\n    position:absolute;\r\n    z-index: 6;\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n\r\n    color: white;\r\n    font-family: 'MyriadPro-Regular';\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n}\r\n\r\n.fadeOutText {\r\n    animation: extraTextfade 5s ease-in-out 0s 1 normal forwards;\r\n}\r\n\r\n.fadeInText {\r\n    animation: fadeIn 1s ease-in-out 0s 1 normal forwards;\r\n}\r\n\r\n@keyframes extraTextfade {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n    20% {\r\n        opacity: 1;\r\n    }\r\n    80% {\r\n        opacity: 1;\r\n    }\r\n    100% {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes fadeIn {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
